import { render } from "./LangSelect.vue?vue&type=template&id=9b8d0c9e"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=9b8d0c9e&lang=scss"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__